import { render } from "./FileBrowserControls.vue?vue&type=template&id=17c66ba9&scoped=true"
import script from "./FileBrowserControls.vue?vue&type=script&lang=js"
export * from "./FileBrowserControls.vue?vue&type=script&lang=js"

import "./FileBrowserControls.vue?vue&type=style&index=0&id=17c66ba9&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c66ba9"]])

export default __exports__